// src/components/TeamNextFixtures.js
// Prossime partite di una squadra dal calendario ufficiale Serie A 2026/27.
// Variante normale (chip con logo avversario, giornata e data) e compatta
// (solo loghi, per le righe di tabella).
import React, { useMemo } from 'react';
import './TeamNextFixtures.css';
import TeamBadge from './TeamBadge';
import Tooltip from './Tooltip';
import { getUpcomingTeamFixtures, formatFixtureDate } from '../data/serieACalendar';

export default function TeamNextFixtures({ team, count = 5, compact = false }) {
  const fixtures = useMemo(
    () => getUpcomingTeamFixtures(team, count),
    [team, count]
  );

  if (!fixtures.length) {
    return <span className="tnf-empty">—</span>;
  }

  if (compact) {
    return (
      <div className="tnf tnf--compact" aria-label={`Prossime partite ${team}`}>
        {fixtures.map((f) => (
          <Tooltip
            as="span"
            key={f.giornata}
            className={`tnf-mini ${f.home ? 'tnf-mini--home' : 'tnf-mini--away'}`}
            content={`G${f.giornata} · ${formatFixtureDate(f.date)} · ${f.home ? `${team}-${f.opponent}` : `${f.opponent}-${team}`}`}
          >
            <TeamBadge team={f.opponent} size={26} showTooltip={false} />
            <span className="tnf-mini__ha">{f.home ? 'C' : 'T'}</span>
          </Tooltip>
        ))}
      </div>
    );
  }

  return (
    <div className="tnf" aria-label={`Prossime partite ${team}`}>
      {fixtures.map((f) => (
        <Tooltip
          as="div"
          key={f.giornata}
          className={`tnf-chip ${f.home ? 'tnf-chip--home' : 'tnf-chip--away'}`}
          content={`${formatFixtureDate(f.date)} · ${f.home ? `${team} - ${f.opponent} (in casa)` : `${f.opponent} - ${team} (in trasferta)`}`}
        >
          <span className="tnf-chip__g">G{f.giornata}</span>
          <TeamBadge team={f.opponent} size={20} showTooltip={false} />
          <span className="tnf-chip__opp">{f.opponent}</span>
          <span className={`tnf-chip__ha ${f.home ? 'is-home' : 'is-away'}`}>
            {f.home ? 'Casa' : 'Trasf.'}
          </span>
        </Tooltip>
      ))}
    </div>
  );
}
